import React from 'react'
import MobileTitleBar from './MobileTitleBar'
import MobileSectionDescription from './MobileSectionDescription'
import styles from './styles'

const MobileContainer = ({
  candidateSlug,
  shortTitle,
  fullTitle,
  optional,
  children,
  editing,
  toggleEditing,
  enabledForCurrentState,
  isEmpty,
  editButtonRef,
  editButtonAriaLabel,
}) => (
  <section className={styles.container}>
    <MobileTitleBar
      candidateSlug={candidateSlug}
      title={shortTitle}
      editing={editing}
      enabledForCurrentState={enabledForCurrentState}
      isEmpty={isEmpty}
      toggleEditing={toggleEditing}
      editButtonRef={editButtonRef}
      editButtonAriaLabel={editButtonAriaLabel}
    />

    <If condition={fullTitle}>
      <MobileSectionDescription fullTitle={fullTitle} optional={optional} />
    </If>

    <div className={styles.content}>{children}</div>
  </section>
)

MobileContainer.defaultProps = {
  optional: false,
}

export default MobileContainer
